import { defineMessages } from 'react-intl'

export const strings = defineMessages({
  amaticSC: {
    id: 'FontSelector.amaticSC',
    defaultMessage: 'Amatic SC',
  },
  domine: {
    id: 'FontSelector.domine',
    defaultMessage: 'Domine',
  },
  greatVibes: {
    id: 'FontSelector.greatVibes',
    defaultMessage: 'Great Vibes',
  },
  lato: {
    id: 'FontSelector.lato',
    defaultMessage: 'Lato',
  },
  lobster: {
    id: 'FontSelector.lobster',
    defaultMessage: 'Lobster',
  },
  montserrat: {
    id: 'FontSelector.montserrat',
    defaultMessage: 'Montserrat',
  },
  monument: {
    id: 'FontSelector.monument',
    defaultMessage: 'Monument Valley',
  },
  openSans: {
    id: 'FontSelector.openSans',
    defaultMessage: 'Open Sans',
  },
  oswald: {
    id: 'FontSelector.oswald',
    defaultMessage: 'Oswald',
  },
  playfairDisplay: {
    id: 'FontSelector.playfairDisplay',
    defaultMessage: 'Playfair Display',
  },
  plusJakartaSans: {
    id: 'FontSelector.plusJakartaSans',
    defaultMessage: 'Plus Jakarta Sans',
  },
  poppins: {
    id: 'FontSelector.poppins',
    defaultMessage: 'Poppins',
  },
  quicksand: {
    id: 'FontSelector.quicksand',
    defaultMessage: 'Quicksand',
  },
  raleway: {
    id: 'FontSelector.raleway',
    defaultMessage: 'Raleway',
  },
  righteous: {
    id: 'FontSelector.righteous',
    defaultMessage: 'Righteous',
  },
  roboto: {
    id: 'FontSelector.roboto',
    defaultMessage: 'Roboto',
  },
  sacramento: {
    id: 'FontSelector.sacramento',
    defaultMessage: 'Sacramento',
  },
  coverFont: {
    id: 'BookBuilder.coverFont',
    defaultMessage: 'Cover Font',
  },
})
